<!--
  @component
  Generates an SVG scatter plot. This component can also work if the x- or y-scale is ordinal, i.e. it has a `.bandwidth` method. See the [timeplot chart](https://layercake.graphics/example/Timeplot) for an example.
 -->
<script>
  import { getContext } from "svelte";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  const { data, xGet, yGet, xScale, yScale, custom } = getContext("LayerCake");

  /**
   * @typedef {Object} Props
   * @property {number} [r=5] - The circle's radius.
   * @property {string} [fill='#0cf'] - The circle's fill color.
   * @property {string} [stroke='#000'] - The circle's stroke color.
   * @property {number} [strokeWidth=0] - The circle's stroke width.
   * @property {number} [opacity=1] - The circle's opacity.
   */

  /** @type {Props} */
  let {
    r = 5,
    fill = "#0cf",
    stroke = "#000",
    strokeWidth = 1,
    opacity = 1,
    tooltip = $bindable()
  } = $props();
</script>

<g class="scatter-group">
  {#each $data.filter((d) => $custom.highlightSameState && $custom.sameStateIDs.has(d.DistrictID)) as d}
    <circle
      class="state-highlight"
      fill="var(--color-yellow-lightest)"
      stroke="none"
      stroke-width={0}
      cx={$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0)}
      cy={$yGet(d) + ($yScale.bandwidth ? $yScale.bandwidth() / 2 : 0)}
      r={18}
    />
  {/each}
  {#each $data.filter((d) => $custom.selectedID == d.DistrictID) as d}
    <circle
      class="behind"
      fill={urbanColors.gray_shade_lighter}
      stroke="none"
      stroke-width=0
      cx={$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0)}
      cy={$yGet(d) + ($yScale.bandwidth ? $yScale.bandwidth() / 2 : 0)}
      r={20}
    ></circle>
  {/each}
  {#each $data as d}
    {@const isEmphasized =
      $custom.selectedID == d.DistrictID ||
      ($custom.highlightSameState && $custom.sameStateIDs.has(d.DistrictID))}
    <circle
      cx={$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0)}
      cy={$yGet(d) + ($yScale.bandwidth ? $yScale.bandwidth() / 2 : 0)}
      {r}
      {fill}
      {stroke}
      opacity={isEmphasized ? 1 : opacity}
      stroke-width={isEmphasized ? 3 : strokeWidth}
      onmousemove={(e) =>
        (tooltip = {
          x: e.pageX,
          y: e.pageY,
          data: d,
          color: fill
        })}
      onmouseleave={() => (tooltip = null)}
      onclick={() => $custom.onClick(d)}
    />
  {/each}
</g>

<style>
  circle.behind {
    z-index: 0;
  }
  circle.state-highlight {
  pointer-events: none;
}
</style>
